import type { FaireProductEntity } from "../../entity_types/product";

export const p_s82zqgcx6x: FaireProductEntity = {
  token: "p_s82zqgcx6x",
  type: "product",
  name: "Baby/Toddler & Youth Hat | Wild Thing",
  brandToken: "b_vllag6pj",
  brandName: "Trek Light",
  imageUrl:
    "https://cdn.faire.com/fastly/26e2ba8885599698e7617ee37cb97fb09ac0536e5dd9c2cf808a00727d631006.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dd0830633ac9b3dcdc71d1dd4796a8a2125a4484840192ef6fd8b019a15fd869.jpeg",
  ],
  priceDollars: 17,
  description:
    "A great kids hat doesn’t just complete the outfit, it sparks smiles, snapshots, and “Where’d you get that?” moments.\n\nMade for little heads, big personalities, and memories that stick.\n\n • Comfortable, everyday fit for babies, toddlers & youth\n • Adjustable, easy-fit options to grow with your child\n • The perfect kids hat for sunny days, messy hair, and big adventures\n • Durable design for park days, road trips & backyard chaos\n • One tree planted for every hat sold\n\nStyle: 5-Panel Unisex Kids Hat\nBrim: Flat Brim\nAdjustable: Snapback\nMaterials: 100% Cotton\nBaby/Toddler Fit: Fits Most Up To 2 Years (~18-19 inches)\nYouth Fit: Fits Most 3+ Years (up to ~21-22 inches)\nBonus: Saves you the trouble of styling your kid's hair for the day\n• Ethically Made In China\n• SKU KH-018\n\nEaster Basket Gift, Baby Shower Gift, Birthday Party, Summer Kids, Back to School Gift, Christmas Gift, Holiday Gift, Birthday Gift, New Baby Gift, Gift for Kids, Gift for Teens, Stocking Stuffer, Summer Gift, Spring Gift, Unique Gift, Gift Under 25, Small Business Gift",
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:30.880Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
